import { UnicUserModel, UserModel, UserTypes } from "@courses-models/user";

/**
 * Helper that'll determine the type of the given user.
 */
export function getUserType(user: UserModel): UserTypes {
    // Assume that e-key users are teachers (we really have no other way of
    // knowing here at the overview!)
    if (user instanceof UnicUserModel) {
        return user.userType;
    }

    // Assume that other kinds of users are are teachers (we really have no
    // other way of knowing in this application)
    return UserTypes.TEACHER;
}
